import * as React from "react";
import { useRecoilSnapshot } from "recoil";

export const RecoilDevTools: React.FC = () => {
  const snapshot = useRecoilSnapshot();

  React.useEffect(() => {
    console.debug("The following atoms were modified:");
    for (const node of snapshot.getNodes_UNSTABLE({
      isModified: true,
    }) as any) {
      console.debug(node.key, snapshot.getLoadable(node));
    }
  }, [snapshot]);

  return null;
};
